import React from 'react';
import cx from 'classnames';
import { ErrorText } from '../error-text';

import './form-control.styles.scss';

export type FormControlProps = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
	errorMessage?: string;
	inputRef?: any;
};

export const FormControl: React.FC<FormControlProps> = ({ className, errorMessage, inputRef, ...otherProps }) => {
	return (
		<>
			<input 
				className={cx('FormControl', 'form-control', className)}
				ref={inputRef}
				{...otherProps}
			/>
			{errorMessage && (
				<ErrorText withTopGap className="FormControl__error-message">
					{errorMessage}
				</ErrorText>
			)}
		</>
	);
};